import { ActionTypes } from '../actions';

const initialState = {
  nationalTopics: [],
  navReferrer: undefined,
};

const AppReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_NATIONAL_TOPICS:
      return { ...state, nationalTopics: action.payload };

    case ActionTypes.SET_NAV_REFERRER:
      return { ...state, navReferrer: action.payload };

    default:
      return state;
  }
};

export default AppReducer;
